module.exports = __webpack_public_path__ + "static/mobile-services-507bee124da2eb7d1c28f89899710b70.png";